<template>
  <h1>World</h1>
  <hr />
  <h2>Main Story & Current Event</h2>
  <MDBRow class="row-cols-2 row-cols-md-3 row-cols-lg-4">
    <MDBCol v-for="s in Object.keys(story)" :key="story[s]['img']">
      <MDBCard
        text="white"
        bg="dark"
        class="mb-3 click-card"
        @click="moveArea(s)"
      >
        <MDBCardImg :src="'images/world/' + story[s]['img'] + '.png'" top />
        <MDBCardBody>
          <MDBCardTitle>{{ story[s]["title"] }}</MDBCardTitle>
        </MDBCardBody>
      </MDBCard>
    </MDBCol>
    <MDBCol v-for="s in Object.keys(curEvents)" :key="curEvents[s]['img']">
      <MDBCard
        text="white"
        bg="dark"
        class="mb-3 click-card"
        @click="moveArea(s)"
      >
        <MDBCardImg :src="'images/world/' + curEvents[s]['img'] + '.png'" top />
        <MDBCardBody>
          <MDBCardTitle>{{ curEvents[s]["title"] }}</MDBCardTitle>
        </MDBCardBody>
      </MDBCard>
    </MDBCol>
  </MDBRow>
  <hr />
  <h2>Permanent Events</h2>
  <MDBRow class="row-cols-2 row-cols-md-3 row-cols-lg-4">
    <MDBCol v-for="s in Object.keys(perEvents)" :key="perEvents[s]['img']">
      <MDBCard
        text="white"
        bg="dark"
        class="mb-3 click-card"
        @click="moveArea(s)"
      >
        <MDBCardImg :src="'images/world/' + perEvents[s]['img'] + '.png'" top />
        <MDBCardBody>
          <MDBCardTitle>{{ perEvents[s]["title"] }}</MDBCardTitle>
        </MDBCardBody>
      </MDBCard>
    </MDBCol>
  </MDBRow>
  <hr />
  <h2>Others</h2>
  <MDBRow class="row-cols-2 row-cols-md-3 row-cols-lg-4">
    <MDBCol v-for="s in Object.keys(others)" :key="others[s]['img']">
      <MDBCard
        text="white"
        bg="dark"
        class="mb-3 click-card"
        @click="moveArea(s)"
      >
        <MDBCardImg :src="'images/world/' + others[s]['img'] + '.png'" top />
        <MDBCardBody>
          <MDBCardTitle>{{ others[s]["title"] }}</MDBCardTitle>
        </MDBCardBody>
      </MDBCard>
    </MDBCol>
  </MDBRow>
  <hr />
  <h2>Old Events</h2>
  <MDBRow class="row-cols-2 row-cols-md-3 row-cols-lg-4">
    <MDBCol v-for="s in Object.keys(oldEvents)" :key="oldEvents[s]['img']">
      <MDBCard
        text="white"
        bg="dark"
        class="mb-3 click-card"
        @click="moveArea(s)"
      >
        <MDBCardImg :src="'images/world/' + oldEvents[s]['img'] + '.png'" top />
        <MDBCardBody>
          <MDBCardTitle>{{ oldEvents[s]["title"] }}</MDBCardTitle>
        </MDBCardBody>
      </MDBCard>
    </MDBCol>
  </MDBRow>
</template>

<script>
// import { useStore } from "vuex";
import {
  MDBCard,
  MDBCardBody,
  MDBCardTitle,
  // MDBCardText,
  MDBCardImg,
  MDBRow,
  MDBCol,
} from "mdb-vue-ui-kit";
export default {
  components: {
    MDBCard,
    MDBCardBody,
    MDBCardTitle,
    // MDBCardText,
    MDBCardImg,
    MDBRow,
    MDBCol,
  },
  computed: {
    world() {
      return this.$store.getters.getWorld;
    },
    maps() {
      return this.$store.getters.getMaps;
    },
    story() {
      return this.world.story;
    },
    events() {
      return this.world.event;
    },
    curEvents() {
      let temp = {};
      for (let x in this.events) {
        if (this.events[x].type == "current") {
          temp[x] = this.events[x];
        }
      }
      return temp;
    },
    perEvents() {
      let temp = {};
      for (let x in this.events) {
        if (this.events[x].type == "permanent") {
          temp[x] = this.events[x];
        }
      }
      return temp;
    },
    oldEvents() {
      let temp = {};
      for (let x in this.events) {
        if (this.events[x].type == "old") {
          temp[x] = this.events[x];
        }
      }
      return temp;
    },
    others() {
      return this.world.others;
    },
  },
  async setup() {
    document.title = "World";
  },
  methods: {
    moveArea(a) {
      this.$router.push("/world/" + a);
    },
  },
};
</script>

<style></style>
